import { gql } from "@apollo/client";

const ECOM_CREATE_QUOTE_MUTATION = gql`
    mutation createQuote(
        $cart_id: String!
        $orderByEmail: String!
        $firstName: String!
        $lastName: String!
        $address1: String!
        $city: String!
        $state: String!
        $zip: String!
        $phoneNumber: String!
        $channel: String!
        $chronos: String
        $userType: String
        $function: String
        $orderNotes: String
        $pc: PcInput
        $accountNumber: String
        $fulfillmentType: String
        $deliveryInstructions: String
        $startDateTime: String
        $endDateTime: String
        $earliestDateTime: String
        $poNumber: String
        $optOutRPP: String
        $optOutFuelCharge: String
        $deliveryCharge: Float
        $driverLicenseState: String
        $driverLicenseNumber: String
        $orderedBy: OrderedByInputEcomQuote
        $sellingChannel: String
        $initiatingChannel: String
        $primarySalesRepId: String
        $jobsite: JobsiteInput
        $pickUpCharge: Float
        $products: [ProductInput]
        $salesItems: [SalesItems]
        $customFields: CustomFields
        $pickUpStoreAddress: String
        $rentalssubtotal: String
        $purchasesubtotal: String
        $rentalprotectplan: String
        $fuelconvenienceplan: String
        $envirofee: String
        $otherfees: String
        $taxes: String
        $subtotal: String
        $totalcost: String
        $dtReservationConfirmationReturnpickupdate: String
        $requestedTime: String
        $customerName: String
    ) {
        ecomCreateQuote(
            input: {
                cart_id: $cart_id,
                orderByEmail: $orderByEmail
                firstName: $firstName
                lastName: $lastName
                address1: $address1
                city: $city
                state: $state
                zip: $zip
                phoneNumber: $phoneNumber
                channel: $channel
                chronos: $chronos
                userType: $userType
                function: $function
                orderNotes: $orderNotes
                pc: $pc
                accountNumber: $accountNumber
                fulfillmentType: $fulfillmentType
                deliveryInstructions: $deliveryInstructions
                startDateTime: $startDateTime
                endDateTime: $endDateTime
                earliestDateTime: $earliestDateTime
                poNumber: $poNumber
                optOutRPP: $optOutRPP
                optOutFuelCharge: $optOutFuelCharge
                deliveryCharge: $deliveryCharge
                driverLicenseState: $driverLicenseState
                driverLicenseNumber: $driverLicenseNumber
                orderedBy: $orderedBy
                sellingChannel: $sellingChannel
                initiatingChannel: $initiatingChannel
                primarySalesRepId: $primarySalesRepId
                jobsite: $jobsite
                pickUpCharge: $pickUpCharge
                products: $products
                salesItems: $salesItems
                customFields: $customFields
                pickUpStoreAddress: $pickUpStoreAddress
                rentalssubtotal: $rentalssubtotal
                purchasesubtotal: $purchasesubtotal
                rentalprotectplan: $rentalprotectplan
                fuelconvenienceplan: $fuelconvenienceplan
                envirofee: $envirofee
                otherfees: $otherfees
                taxes: $taxes
                subtotal: $subtotal
                totalcost: $totalcost
                dtReservationConfirmationReturnpickupdate: $dtReservationConfirmationReturnpickupdate
                requestedTime: $requestedTime
                customerName: $customerName
            }
        ) {
            status
            message
            magento_order_id
            data {
                QuoteId
            }
        }
    }
`;

export default ECOM_CREATE_QUOTE_MUTATION;